import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function RenderInactiveUserModal(props){

    const handleClose = () => {
        props.setShow(false);
        props?.setConfirmUserInactive(false);
    };
    return (
        <Modal show={props.show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Inactive the Selected user?</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to make this user inactive?</Modal.Body>
                                    <div
                                      style={{
                                        background: "#FFF8C6",
                                        color: "#8B5A2B",
                                        padding: "8px 12px",
                                        borderRadius: "6px",
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        margin: "10px"
                                      }}
                                    >
                                      <span>
                                        <strong>Note: </strong>If any operation is performed on this user account with respect to status then same operation will be applied to all your created users and nested also if exists.
                                      </span>
                                    </div>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Close</Button>
                <Button variant="primary" onClick={() => props.setConfirmUserInactive(true)}>Yes</Button>
            </Modal.Footer>
        </Modal>
    );

}

export default RenderInactiveUserModal;